<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12">
        <v-form
          name="customerform"
          @submit.prevent=""
          v-model="customerFormValid"
        >
          <v-card class="mb-12" color="grey lighten-5">
            <v-container>
              <v-row>
                <v-col cols="12" xs="12" sm="4">
                  <v-text-field
                    label="*SLA Gerichtnr"
                    name="gerichtnr"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="meal.gerichtnr"
                    required
                    :rules="requiredRule"
                  />
                </v-col>

                <v-col cols="12" xs="12" sm="8">
                  <v-text-field
                    label="*Name"
                    name="name"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="meal.name"
                    required
                    :rules="requiredRule"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="3">
                  <v-select
                    label="Kategorie"
                    v-model="mealKategorie"
                    :items="kategorien"
                    color="purple"
                    name="kategorie"
                    ref="kategorie"
                  />
                </v-col>

                <v-col sm="3">
                  <v-currency-field
                    currency="EUR"
                    locale="de"
                    v-model="meal.preis"
                    label="VK Preis netto"
                  />
                </v-col>
                <v-col sm="3">
                  <MenuDatePicker
                    label="Anzeigen von"
                    hide-details
                    locale="de-de"
                    :first-day-of-week="1"
                    v-model="meal.von"
                  />
                </v-col>
                <v-col sm="3">
                  <MenuDatePicker
                    label="Anzeigen bis"
                    hide-details
                    locale="de-de"
                    :first-day-of-week="1"
                    v-model="meal.bis"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-switch
                    v-model="meal.grossgebinde"
                    label="Großgebinde"
                    color="green"
                  />
                </v-col>
              </v-row>
              <v-row v-if="meal.grossgebinde">
                <v-col>
                  <v-chip-group multiple v-model="meal.orderDays">
                    <v-chip
                      filter
                      active-class="daySelected"
                      v-for="item in wochentage"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.text }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col sm="2">
                  <v-checkbox
                    label="Glutenfrei"
                    v-model="meal.glutenfrei"
                    color="success"
                  />
                </v-col>
                <v-col sm="2">
                  <v-checkbox
                    label="Laktosefrei"
                    v-model="meal.laktosefrei"
                    color="success"
                  />
                </v-col>
                <v-col sm="2">
                  <v-checkbox
                    label="Vegetarisch"
                    v-model="meal.vegetarisch"
                    color="success"
                  />
                </v-col>

                <v-col sm="4">
                  <v-checkbox
                    label="Schweinefleisch frei"
                    v-model="meal.schweinefleischfrei"
                    color="success"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12">
                  <v-select
                    label="Allergene"
                    multiple
                    chips
                    v-model="meal.allergene"
                    :items="allergenList"
                    name="allergene"
                    color="purple"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col sm="12">
                  <v-textarea
                    label="Beschreibung"
                    v-model="meal.beschreibung"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12">
                  <v-textarea
                    label="Zutatenliste"
                    v-model="meal.zutatenliste"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12">
                  <MultiUploader
                    v-if="dataReady"
                    ref="imageUploader"
                    :axiosInstance="getAxiosInstance()"
                    :maxFiles="8"
                    :autoUpload="false"
                    hideUploadButton
                    uploadUrl="/meal/images"
                    :existentItems="meal.bilder"
                    numberFormat="de-DE"
                    displayText="Drag'n drop oder klicken um Dateien hochzuladen"
                    @filesSelected="filesSelectedEvent"
                    @maxFilesReached="maxFilesReached"
                    @imageRemoved="imageRemoved"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-btn
                outlined
                :to="{ path: '/meals' }"
                color="error"
                type="button"
                name="cancel"
                >Abbrechen</v-btn
              >
              <v-spacer />
              <v-btn
                color="success"
                @click="save()"
                :disabled="!customerFormValid"
              >
                Speichern
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataService from "@/services/DataService";
import MealService from "@/services/MealService.js";
//import MenuTimePicker from "@/components/MenuTimePicker.vue";
import MenuDatePicker from "@/components/MenuDatePicker";
import MultiUploader from "@/components/MultiUploader.vue";
//import MealCategorySelectbox from "@/components/meals/MealCategorySelectbox";

export default {
  name: "MealForm",
  components: { MultiUploader, MenuDatePicker },
  data: () => ({
    dataReady: false,
    meal: {
      _id: null,
      gerichtnr: "",
      name: "",
      preis: 0,
      kategorie: "",
      schweinefleischfrei: false,
      glutenfrei: false,
      laktosefrei: false,
      vegetarisch: false,
      vegan: false,
      grossgebinde: false,
      orderDays: [],
      energie: 0,
      von: null,
      bis: null,
      beschreibung: "",
      zutatenliste: "",
      allergene: [],
      bilder: []
    },
    wochentage: [
      { text: "Montag", value: 1 },
      { text: "Dienstag", value: 2 },
      { text: "Mittwoch", value: 3 },
      { text: "Donnerstag", value: 4 },
      { text: "Freitag", value: 5 },
      { text: "Samstag", value: 6 },
      { text: "Sonntag", value: 7 }
    ],

    activeImageUploads: null,
    placeholderImage: "",

    requiredRule: [value => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      v =>
        /^$/.test(v) ||
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail Format ungültig"
    ],
    requiredEmailRules: [
      v => !!v || "E-mail wird benötigt!",
      v =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail Format ungültig"
    ],

    formValid: true,
    customerFormValid: false
  }),

  methods: {
    maxFilesReached() {
      this.$notify({
        group: "dataline",
        type: "warn",
        title: "Max Bilder erreicht",
        text: "Max Anzahl der Bilder erreicht"
      });
    },

    filesSelectedEvent() {},
    imageRemoved(evt) {
      if (!evt.file[0].existent) {
        return false;
      }

      MealService.removeFile(this.meal._id, evt.file[0].filename)
        .then(() => {
          this.meal.bilder = this.meal.bilder.filter(
            el => el.filename !== evt.file[0].filename
          );
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Bild entfernt",
            text: "Bild wurde entfernt"
          });
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: "Bild konnte nicht entfernt werden"
          });
        });
    },

    save() {
      //Save customer
      MealService.save({
        id: this.meal._id,
        data: this.meal
      })

        .then(result => {
          //if success redirecht to list

          if (this.$refs.imageUploader.files.length > 0) {
            this.$refs.imageUploader.formData = [
              {
                name: "_id",
                value: this.meal._id ? this.meal._id : result.data.data._id
              }
            ];
            this.$refs.imageUploader.upload();
          }
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Gericht gespeichert",
            text: "Gericht erfolgreich gespeichert"
          });

          this.$router.push({ name: "meals" });
        })
        .catch(error => {
          //on error alert error
          console.log(error);
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        });
    },

    getAxiosInstance() {
      return DataService.apiClient;
    }
  },
  computed: {
    allergenList() {
      return this.$store.getters["meal/getAllergene"];
    },
    mealKategorie: {
      get() {
        if (this.meal.subkategorie) {
          return this.meal.kategorie + "," + this.meal.subkategorie;
        } else {
          return this.meal.kategorie;
        }
      },
      set(value) {
        const parts = String(value).split(",");
        this.meal.kategorie = parts[0];
        this.meal.subkategorie = parts[1];
      }
    },
    kategorien() {
      const categories = this.$store.getters["meal/getMealCategories"];
      let foundItems = [];
      categories.forEach(item => {
        foundItems.push({ text: item.name, value: item.name });

        item.subcategories.forEach(cat => {
          foundItems.push({
            text: cat,
            value: item.name + "," + cat,
            group: item.name
          });
        });
      });
      return foundItems;
    }
  },
  created() {
    const id = this.$route.params.id;

    if (id) {
      this.$store.commit("SET_APP_LOADING", true);

      const getCategories = async () => {
        await this.$store.dispatch("meal/fetchMealCategories");
      };

      getCategories();

      MealService.get(id)
        .then(item => {
          this.meal = item.data.data[0];
          //this.$refs.imageUploader.setExistentItems(item.data.data[0].bilder);
        })
        .catch(error => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
          this.dataReady = true;
        });
    } else {
      this.dataReady = true;
    }
  }
};
</script>
<style scoped>
.daySelected {
  background-color: #c25443;
  color: white !important;
}
</style>
